class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('.header-drawer__details');
    this.toggle = this.querySelector('.header-drawer__toggle');
    this.drawer = this.querySelector('.header-drawer__drawer');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.toggle.addEventListener('click', (event) => {
      event.preventDefault();
      this.details.open ? this.close() : this.open();
    });
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open() {
    this.details.open = true;
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.drawer.classList.add('active')});
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.drawer.classList.remove('active');
    setTimeout(() => {
      this.details.open = false;
    }, 120);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('header-drawer', HeaderDrawer);
